import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import Program from "../views/Program";
import Product from "../views/Product";
import About from "../views/About";
import Contact from "../views/Contact";
import ProDetail from "../views/ProDetail";

Vue.use(VueRouter);

const routes = [
  {
    path:"/",
    redirect:"/home",
  },
  {
    path: "/home",
    name: "home",
    component: Home
  },
  {
    path: "/program",
    name: "program",    
    component: Program
  },
  {
    path: "/product",
    name: "product",    
    component: Product
  },
  {
    path: "/about",
    name: "about",    
    component: About
  },
  {
    path: "/contact",
    name: "contact",    
    component: Contact
  },
  {
    path: "/prodetail/:id",
    name: "prodetail",    
    component: ProDetail
  }
];

const router = new VueRouter({
  linkActiveClass:"active",
  routes
});

export default router;
